import React from 'react';
import Layout from "../components/Layout";
import ApartmentCard from "../components/ApartmentCard";

const ApartmentsPage = () => {
    return (
        <Layout>
            <ApartmentCard />
        </Layout>
    );
};

export default ApartmentsPage;
